import React, {useState} from 'react';
import {Card, CardBody, CardHeader} from "reactstrap";
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import {Link} from "react-router-dom";
import appUserRoutes from "../../../appUserRoutes";
import {getByModuleId, MODULE_WIRING} from "../Modules";
import LoadingSpinner from "../../LoadingSpinner/LoadingSpinner";
import {useTecRmi} from "../../../contexts/TecRmiContext";
import ModuleCardList from "../ModuleCardList";

const WiringCard = props => {
  const { getApiPrimaryParams, ident } = useTecRmi()
  const [wiring, setWiring] = useState([])

  useDidMountEffect(() => {
    apiUser.tecRmi.wiring.list(getApiPrimaryParams())
      .then(res => setWiring(res.data))
  })

  return (
    <Card className="h-100">
      <CardHeader className="p-1">
        <Link className="d-flex flex-row flex-nowrap align-items-center py-1" to={appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_WIRING, 'uriName'))}>
          <img src={getByModuleId(MODULE_WIRING, 'icon')} style={{ height: 24 }} />
          <span className="ml-1">{getByModuleId(MODULE_WIRING, 'name')}</span>
        </Link>
      </CardHeader>
      <CardBody>
        {
          wiring.length > 0
            ? <ModuleCardList items={wiring.map((wiring, key) => <Link to={appUserRoutes.tecRmi.tabModule(ident, getByModuleId(MODULE_WIRING, 'uriName'), wiring.MainGroupId)} key={key.toString()}>{wiring.MainGroupName}</Link>)} />
            : <LoadingSpinner />
        }
      </CardBody>
    </Card>
  );
};

export default WiringCard;